/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeDashboardQuestStats } from './ChallengeDashboardQuestStats';
import {
    ChallengeDashboardQuestStatsFromJSON,
    ChallengeDashboardQuestStatsFromJSONTyped,
    ChallengeDashboardQuestStatsToJSON,
    ChallengeDashboardQuestStatsToJSONTyped,
} from './ChallengeDashboardQuestStats';

/**
 * 
 * @export
 * @interface ChallengeDashboardSegmentStats
 */
export interface ChallengeDashboardSegmentStats {
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    segmentNumber: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengeDashboardSegmentStats
     */
    segmentName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeDashboardSegmentStats
     */
    isFullCampaign: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeDashboardSegmentStats
     */
    displayTab: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    startAt: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    endAt: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    participantsWithProgression: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    participationPercent: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    newUsersInSegment?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    newUsersWithProgression?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardSegmentStats
     */
    segmentEntries?: number;
    /**
     * 
     * @type {Array<ChallengeDashboardQuestStats>}
     * @memberof ChallengeDashboardSegmentStats
     */
    quests: Array<ChallengeDashboardQuestStats>;
}

/**
 * Check if a given object implements the ChallengeDashboardSegmentStats interface.
 */
export function instanceOfChallengeDashboardSegmentStats(value: object): value is ChallengeDashboardSegmentStats {
    if (!('segmentNumber' in value) || value['segmentNumber'] === undefined) return false;
    if (!('segmentName' in value) || value['segmentName'] === undefined) return false;
    if (!('isFullCampaign' in value) || value['isFullCampaign'] === undefined) return false;
    if (!('displayTab' in value) || value['displayTab'] === undefined) return false;
    if (!('startAt' in value) || value['startAt'] === undefined) return false;
    if (!('endAt' in value) || value['endAt'] === undefined) return false;
    if (!('participantsWithProgression' in value) || value['participantsWithProgression'] === undefined) return false;
    if (!('participationPercent' in value) || value['participationPercent'] === undefined) return false;
    if (!('quests' in value) || value['quests'] === undefined) return false;
    return true;
}

export function ChallengeDashboardSegmentStatsFromJSON(json: any): ChallengeDashboardSegmentStats {
    return ChallengeDashboardSegmentStatsFromJSONTyped(json, false);
}

export function ChallengeDashboardSegmentStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeDashboardSegmentStats {
    if (json == null) {
        return json;
    }
    return {
        
        'segmentNumber': json['segmentNumber'],
        'segmentName': json['segmentName'],
        'isFullCampaign': json['isFullCampaign'],
        'displayTab': json['displayTab'],
        'startAt': json['startAt'],
        'endAt': json['endAt'],
        'participantsWithProgression': json['participantsWithProgression'],
        'participationPercent': json['participationPercent'],
        'newUsersInSegment': json['newUsersInSegment'] == null ? undefined : json['newUsersInSegment'],
        'newUsersWithProgression': json['newUsersWithProgression'] == null ? undefined : json['newUsersWithProgression'],
        'segmentEntries': json['segmentEntries'] == null ? undefined : json['segmentEntries'],
        'quests': ((json['quests'] as Array<any>).map(ChallengeDashboardQuestStatsFromJSON)),
    };
}

export function ChallengeDashboardSegmentStatsToJSON(json: any): ChallengeDashboardSegmentStats {
    return ChallengeDashboardSegmentStatsToJSONTyped(json, false);
}

export function ChallengeDashboardSegmentStatsToJSONTyped(value?: ChallengeDashboardSegmentStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'segmentNumber': value['segmentNumber'],
        'segmentName': value['segmentName'],
        'isFullCampaign': value['isFullCampaign'],
        'displayTab': value['displayTab'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'participantsWithProgression': value['participantsWithProgression'],
        'participationPercent': value['participationPercent'],
        'newUsersInSegment': value['newUsersInSegment'],
        'newUsersWithProgression': value['newUsersWithProgression'],
        'segmentEntries': value['segmentEntries'],
        'quests': ((value['quests'] as Array<any>).map(ChallengeDashboardQuestStatsToJSON)),
    };
}

